import React from 'react';
import PaymentCodes from '../../components/spravochniki/paymentCode/paymentCodes'

function Page(props) {
    return (
        <>
          <PaymentCodes />
        </>
    );
}

export default Page;